type CommandKey = 'decks' | 'discard' | 'dice' | 'token' | 'coin' | 'chat' | 'history' | 'players' | 'help';

interface CommandDockProps {
  onCommand: (command: CommandKey) => void;
  activePanel: string | null;
  isConnected: boolean;
}

const commands: Array<{ key: CommandKey; icon: string; label: string; shortLabel: string; panel?: string }> = [
  { key: 'decks', icon: '▦', label: 'Deck Library', shortLabel: 'Decks', panel: 'decks' },
  { key: 'discard', icon: '♻', label: 'Add Discard', shortLabel: 'Discard' },
  { key: 'dice', icon: '⚄', label: 'Add Dice', shortLabel: 'Dice' },
  { key: 'token', icon: '●', label: 'Add Token', shortLabel: 'Token' },
  { key: 'coin', icon: '¢', label: 'Add Coin', shortLabel: 'Coin' },
  { key: 'chat', icon: '✉', label: 'Chat', shortLabel: 'Chat', panel: 'chat' },
  { key: 'history', icon: '↺', label: 'History', shortLabel: 'Log', panel: 'history' },
  { key: 'players', icon: '◉', label: 'Players', shortLabel: 'Players', panel: 'players' },
  { key: 'help', icon: '?', label: 'Controls', shortLabel: 'Help', panel: 'help' }
];

export default function CommandDock({ onCommand, activePanel, isConnected }: CommandDockProps) {
  return (
    <nav className="table-command-dock pointer-events-auto fixed left-3 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-1.5 p-1.5 md:flex">
      {commands.map(command => {
        const active = command.panel && activePanel === command.panel;
        const disabled = command.key === 'chat' && !isConnected;
        return (
          <button
            key={command.key}
            type="button"
            onClick={() => onCommand(command.key)}
            disabled={disabled}
            className={`table-dock-button ${active ? 'table-dock-button-active' : ''}`}
            aria-label={command.label}
          >
            <span className="dock-button-icon" aria-hidden="true">{command.icon}</span>
            <span className="dock-button-label">{command.shortLabel}</span>
          </button>
        );
      })}
    </nav>
  );
}

export type { CommandKey };
